import * as React from "react";
import get from "lodash/get";

import "./ProgressBar.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

export interface ProgressBarProps extends ComponentBaseProps {
  classNames: string;
  style?: React.CSSProperties;
  configName: string;
  currentPoints: number;
  pointsToNextReward: number;
  progressBarColor: string;
  remainingBarColor: string;
  strokeWidth: number;
  radius: number;
  displayType: "linear" | "circular";
}

export class ProgressBar extends ComponentBase<ProgressBarProps> {
  render() {
    const {
      classNames,
      configName,
      currentPoints,
      pointsToNextReward,
      progressBarColor,
      remainingBarColor,
      strokeWidth,
      displayType,
      radius,
      style,
    } = this.props;

    const normalizedRadius = radius - strokeWidth * 2;
    const circumference = normalizedRadius * 2 * Math.PI;

    const barWidth = "500px";
    const barHeight = "50px";

    const percent = currentPoints / pointsToNextReward;
    if (displayType === "circular") {
      return (
        <div
          id={configName}
          onDragStart={this.onDragStart}
          onMouseDown={this.onMouseDown}
          className={`ProgressBar-container ${classNames || ""}`}
          style={{ ...style, height: radius * 2, width: radius * 2 }}
          aria-label={get(this.props, "label", "")}
          ref={(component) => (this.component = component)}
        >
          <svg height={radius * 2} width={radius * 2}>
            <circle
              stroke={remainingBarColor}
              strokeWidth={strokeWidth}
              fill="transparent"
              r={normalizedRadius}
              cx={radius}
              cy={radius}
            />
            <circle
              stroke={progressBarColor}
              strokeWidth={strokeWidth}
              fill="transparent"
              r={normalizedRadius}
              cx={radius}
              cy={radius}
              style={{
                strokeDasharray: `${circumference} ${circumference}`,
                strokeDashoffset: -(
                  Number(circumference) -
                  Number(percent) * Number(circumference)
                ),
                transform: "rotate(-90deg)",
                transformOrigin: "50% 50%",
                transition: "stroke-dashoffset 0.35s",
              }}
            />
          </svg>
        </div>
      );
    } else {
      return (
        <div
          id={this.props.configName}
          className={`ProgressBar-container ${classNames || ""}`}
          style={{
            width: barWidth,
            backgroundColor: remainingBarColor,
            height: barHeight,
            position: "relative",
          }}
          ref={(component) => (this.component = component)}
        >
          <div
            style={{
              width: percent * 100 + "%",
              height: barHeight,
              backgroundColor: progressBarColor,
            }}
          />
        </div>
      );
    }
  }
}
